const formatUuid = (val: string | null | undefined): string => {
  if (!val) {
    return ''
  }
  return val.replace(/-/g, '')
}

export default formatUuid
